import React from 'react'
import Top from './Top'
import Foot from './Foot'
import ChromeAlert from './ChromeAlert'

function MainWeb(props) {
    return (
        <div>
            <ChromeAlert/>
            <Top/>
            <div>
                {props.children}
            </div>
            <Foot/>
        </div>
    )
}

export default MainWeb